var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_386",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29208",
    "data-name": "Group 29208",
    transform: "translate(583 11197)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -583, -11197)",
    filter: "url(#Ellipse_386)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_386-2",
    "data-name": "Ellipse 386",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_2_",
    "data-name": "svgexport-17 (2)",
    transform: "translate(-562.555 -11180.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49906",
    "data-name": "Path 49906",
    d: "M40.236.079c-6.9,1.535-12.092,8.141-12.092,16.058A19.874,19.874,0,0,0,32.57,28.89a2.391,2.391,0,0,0,1.835.848h8.9V.976a3.324,3.324,0,0,0-3.07-.9Z",
    transform: "translate(-27.252 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49907",
    "data-name": "Path 49907",
    d: "M251.57.079a3.324,3.324,0,0,0-3.07.9V29.738h8.9a2.39,2.39,0,0,0,1.835-.848,19.874,19.874,0,0,0,4.426-12.752c0-7.917-5.19-14.523-12.092-16.058Z",
    transform: "translate(-232.445 0)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49908",
    "data-name": "Path 49908",
    d: "M161.692,385.748a6.971,6.971,0,0,0-5.364-5.268,6.854,6.854,0,0,0-1.372-.138h0a6.881,6.881,0,0,0-5.39,2.613,6.977,6.977,0,0,0-1.522,4.36v1.054h13.825v-1.054A7.022,7.022,0,0,0,161.692,385.748Z",
    transform: "translate(-138.901 -354.171)",
    fill: "#d4d4d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49909",
    "data-name": "Path 49909",
    d: "M154.391,389.673a18.774,18.774,0,0,1-.806-5.443v-1.863a6.911,6.911,0,0,0-4.019,2.474,7,7,0,0,0-1.522,4.36v1.054h6.523Z",
    transform: "translate(-138.902 -356.055)",
    fill: "#b9bbbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49910",
    "data-name": "Path 49910",
    d: "M149.565,395.014a6.977,6.977,0,0,0-1.522,4.36v1.054h4.426a20.793,20.793,0,0,1-.892-6.025v-1.111A6.98,6.98,0,0,0,149.565,395.014Z",
    transform: "translate(-138.901 -366.23)",
    fill: "#ce857a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49911",
    "data-name": "Path 49911",
    d: "M166.477,394.4v-1.111a6.981,6.981,0,0,0-2.012,1.722q-.126.158-.242.323a1,1,0,0,0,.064,1.224l1.048,1.231-.286.745a1.009,1.009,0,0,0,.619,1.317l1.7.574A20.8,20.8,0,0,1,166.477,394.4Zm8.769.611a6.977,6.977,0,0,1,1.522,4.36v1.054h-4.426a20.793,20.793,0,0,0,.892-6.025v-1.111A6.98,6.98,0,0,1,175.245,395.014Z",
    transform: "translate(-153.8 -366.23)",
    fill: "#d6948c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49912",
    "data-name": "Path 49912",
    d: "M285.524,394.4v-1.111a6.982,6.982,0,0,1,2.254,2.044,1,1,0,0,1-.064,1.225l-1.048,1.231.286.745a1.009,1.009,0,0,1-.619,1.317l-1.7.574A20.8,20.8,0,0,0,285.524,394.4Z",
    transform: "translate(-266.091 -366.23)",
    fill: "#e8b5b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49913",
    "data-name": "Path 49913",
    d: "M206.16,365.53l-3.378-2.051L199.4,365.53c0,.007,0,.784,0,1.079a.728.728,0,0,0,.031.221,1.925,1.925,0,0,0,3.346.644,1.925,1.925,0,0,0,3.346-.644.727.727,0,0,0,.031-.221c0-.3,0-1.073,0-1.079Z",
    transform: "translate(-186.728 -338.468)",
    fill: "#efedee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49914",
    "data-name": "Path 49914",
    d: "M44.169,166.466H18.3a3.122,3.122,0,0,0,0,6.243H44.169a3.122,3.122,0,0,0,0-6.243Z",
    transform: "translate(-15.182 -155.012)",
    fill: "#ffcbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49915",
    "data-name": "Path 49915",
    d: "M75.636,24.063A12.934,12.934,0,1,0,86.415,36.816,13.016,13.016,0,0,0,75.636,24.063Z",
    transform: "translate(-57.427 -22.24)",
    fill: "#ffddcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49916",
    "data-name": "Path 49916",
    d: "M64.839,36.834a12.95,12.95,0,0,1,10.8-12.771,12.934,12.934,0,1,0,0,25.507A12.913,12.913,0,0,1,64.839,36.834Z",
    transform: "translate(-57.427 -22.24)",
    fill: "#ffcbbe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28912",
    "data-name": "Group 28912",
    transform: "translate(6.422 16.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49917",
    "data-name": "Path 49917",
    d: "M111.1,243.755a2.107,2.107,0,1,0,2.587,2.051A2.366,2.366,0,0,0,111.1,243.755Zm14.092,0a2.107,2.107,0,1,0,2.587,2.051A2.366,2.366,0,0,0,125.189,243.755Z",
    transform: "translate(-108.51 -243.755)",
    fill: "#ff8e9e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28913",
    "data-name": "Group 28913",
    transform: "translate(9.969 15.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49918",
    "data-name": "Path 49918",
    d: "M160.57,221.833a.516.516,0,0,0-.516.516v1.07a.516.516,0,1,0,1.032,0v-1.07a.516.516,0,0,0-.516-.516Zm11.14,0a.516.516,0,0,0-.516.516v1.07a.516.516,0,1,0,1.032,0v-1.07A.516.516,0,0,0,171.71,221.833ZM167.948,223a.516.516,0,0,0-.728.05,1.43,1.43,0,0,1-2.159,0,.516.516,0,1,0-.778.678,2.462,2.462,0,0,0,3.715,0A.516.516,0,0,0,167.948,223Z",
    transform: "translate(-160.054 -221.833)",
    fill: "#313d40"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49919",
    "data-name": "Path 49919",
    d: "M83.039,24.493a13.6,13.6,0,0,0-26.4,0l.649.161a12.958,12.958,0,0,0-.38,3.122,15.488,15.488,0,0,0,12.933-6.984A15.488,15.488,0,0,0,82.77,27.776a12.958,12.958,0,0,0-.38-3.122Z",
    transform: "translate(-53.783 -13.2)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49920",
    "data-name": "Path 49920",
    d: "M67.573,14.362a13.578,13.578,0,0,0-10.938,10.13l.649.161a12.958,12.958,0,0,0-.38,3.122,15.442,15.442,0,0,0,6.178-1.29,24.961,24.961,0,0,1,6.755-12.311A13.7,13.7,0,0,0,67.573,14.362Z",
    transform: "translate(-53.783 -13.199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl);
export default __webpack_public_path__ + "static/media/Girl.64f31769ee632820ac31d8e4807557a2.svg";
export { ForwardRef as ReactComponent };